import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, updateSeriesEntry } from 'store/data/entries';

type HandlerInput = Parameters<typeof updateSeriesEntry>;

export function useUpdateSeriesEntry(): Operation<(...input: HandlerInput) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.UPDATE_SERIES_ENTRY);

	async function handler(...input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		await dispatch(updateSeriesEntry(...input));
	}

	return [{ loading, error }, handler];
}
